import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBrandApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getBrandListApi = createAsyncThunk('getBrandList', async (payload) => {
  // console.log('payload', payload);
  return await getBrandApi(payload);
});

const getBrandListSlice = createSlice({
  name: 'getBrandList', // Unique Name
  initialState,
  reducers: {
    getBrandListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBrandListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getBrandListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getBrandListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getBrandListReset } = getBrandListSlice.actions;

export default getBrandListSlice.reducer;
